import styled from "styled-components";

export const SOnboardingTemplatesModalArticle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
